import Cookies from 'js-cookie';
import { wootOn, addClass, loadCSS } from './DOMHelpers';

import {
  body,
  widgetHolder,
  createBubbleHolder,
  initializeClosepopupJSON,
  initializeFirstTimepopupJSON,
  createBubbleIcon,
  createFirstTimeWidgetPopUp,
  createUnreadWidgetPopUp,
  chatBubble,
  bubbleHolder,
  onClickChatBubble,
  onBubbleClick,
  setBubbleText,
} from './bubbleHelpers.js';
import { dispatchWindowEvent } from 'shared/helpers/CustomEventHelper';
import { WIDGET_EVENTS } from './constants';

const EVENT_NAME = WIDGET_EVENTS.READY;

var homepopupsettingsJSON;
var closepopupsettingJSON;
var popupConfigsJSON;
var isPopupMessageEnabled;
var widgetColor;

export const IFrameHelper = {
  getUrl({ baseUrl, websiteToken }) {
    return `${baseUrl}/widget?website_token=${websiteToken}`;
  },

  // Helper to get the appropriate storage context (parent window or current window)
  getStorageContext() {
    // Try parent window first if we're in an iframe
    if (window.parent && window.parent.localStorage) {
      return window.parent.localStorage;
    }

    return window.localStorage;
  },

  // Helper function to get conversation token from appropriate storage
  getConversationToken() {
    try {
      const storage = this.getStorageContext();
      const storedData = storage.getItem('cw_conversation');

      if (!storedData) return null;

      const parsedData = JSON.parse(storedData);
      if (parsedData.expirationDate > Date.now()) {
        return parsedData.value;
      }

      // Remove expired token
      this.removeConversationToken();
      return null;
    } catch (error) {
      // Remove corrupted token and return null
      this.removeConversationToken();
      return null;
    }
  },

  // Helper function to store conversation token in appropriate storage
  storeConversationToken(token) {
    const EXPIRATION_TIME = 365 * 24 * 60 * 60 * 1000;
    const expirationDate = Date.now() + EXPIRATION_TIME;
    const dataToStore = { value: token, expirationDate };
    try {
      const storage = this.getStorageContext();
      storage.setItem('cw_conversation', JSON.stringify(dataToStore));
    } catch (error) {
      // Fallback to current window if parent access fails
      localStorage.setItem('cw_conversation', JSON.stringify(dataToStore));
    }
  },

  // Helper function to remove conversation token from appropriate storage
  removeConversationToken() {
    try {
      const storage = this.getStorageContext();
      storage.removeItem('cw_conversation');
    } catch (error) {
      // Fallback to current window if parent access fails
      window.localStorage.removeItem('cw_conversation');
    }
  },

  createFrame: ({
    baseUrl,
    websiteToken,
    widgetColor: widgetColorFromProps,
    homepopupsettingOptions,
    closepopupsettingOptions,
    popup_configs,
    popup_message_enabled,
  }) => {
    const iframe = document.createElement('iframe');

    // Use the helper function to get token from parent window
    const cwCookie = IFrameHelper.getConversationToken();

    let widgetUrl = IFrameHelper.getUrl({ baseUrl, websiteToken });
    if (cwCookie) {
      widgetUrl = `${widgetUrl}&cw_conversation=${cwCookie}`;
    }
    iframe.setAttribute('data-src', widgetUrl);

    if (popup_message_enabled && popup_configs) {
      const deviceType = window.innerWidth >= 670 ? 'desktop' : 'mobile';
      const fullConfig =
        typeof popup_configs === 'object'
          ? popup_configs
          : JSON.parse(popup_configs);

      const config = fullConfig[deviceType];

      if (config && !window.$chatwoot.hideMessageBubble) {
        let timer = config.time_to_appear || 1;
        setTimeout(() => {
          createFirstTimeWidgetPopUp(config, widgetColor);
        }, timer * 1000);
      }
    }

    // iframe.src = widgetUrl;
    IFrameHelper.loadLimeBubble(
      widgetColor,
      homepopupsettingOptions,
      closepopupsettingOptions,
      popup_configs,
      popup_message_enabled
    );

    iframe.id = 'chatwoot_live_chat_widget';
    iframe.style.visibility = 'hidden';

    // let holderClassName = `woot-widget-holder woot--hide woot-elements--${window.$chatwoot.position}`;

    let holderClassName =
      window.innerWidth >= 670
        ? `woot-widget-holder woot--hide woot-elements--${window.$chatwoot.position}`
        : `woot-widget-holder woot--hide woot-elements--${window.$chatwoot.position_mobile}`;

    if (window.$chatwoot.hideMessageBubble) {
      holderClassName += ` woot-widget--without-bubble`;
    }
    addClass(widgetHolder, holderClassName);
    widgetHolder.appendChild(iframe);
    body.appendChild(widgetHolder);
    IFrameHelper.initPostMessageCommunication();
    IFrameHelper.initLocationListener();
    IFrameHelper.initWindowSizeListener();
    IFrameHelper.preventDefaultScroll();
  },
  getAppFrame: () => document.getElementById('chatwoot_live_chat_widget'),
  sendMessage: (key, value) => {
    const element = IFrameHelper.getAppFrame();
    element.contentWindow.postMessage(
      `chatwoot-widget:${JSON.stringify({ event: key, ...value })}`,
      '*'
    );
  },
  initLocationListener: () => {
    window.onhashchange = () => {
      IFrameHelper.setCurrentUrl();
    };
  },
  initPostMessageCommunication: () => {
    window.onmessage = (e) => {
      if (
        typeof e.data !== 'string' ||
        e.data.indexOf('chatwoot-widget:') !== 0
      ) {
        return;
      }
      const message = JSON.parse(e.data.replace('chatwoot-widget:', ''));
      if (typeof IFrameHelper.events[message.event] === 'function') {
        IFrameHelper.events[message.event](message);
      }
    };
  },
  initWindowSizeListener: () => {
    wootOn(window, 'resize', () => IFrameHelper.toggleCloseButton());
  },
  preventDefaultScroll: () => {
    widgetHolder.addEventListener('wheel', (event) => {
      const deltaY = event.deltaY;
      const contentHeight = widgetHolder.scrollHeight;
      const visibleHeight = widgetHolder.offsetHeight;
      const scrollTop = widgetHolder.scrollTop;

      if (
        (scrollTop === 0 && deltaY < 0) ||
        (visibleHeight + scrollTop === contentHeight && deltaY > 0)
      ) {
        event.preventDefault();
      }
    });
  },
  events: {
    loaded: (message) => {
      // Store conversation token using simplified helper
      IFrameHelper.storeConversationToken(message.config.authToken);

      window.$chatwoot.hasLoaded = true;
      IFrameHelper.sendMessage('config-set', {
        locale: window.$chatwoot.locale,
        position: window.$chatwoot.position,
        position_mobile: window.$chatwoot.position_mobile,
        hideMessageBubble: window.$chatwoot.hideMessageBubble,
        showPopoutButton: window.$chatwoot.showPopoutButton,
      });
      IFrameHelper.onLoad();
      IFrameHelper.setCurrentUrl();
      IFrameHelper.toggleCloseButton();

      let el = document.querySelector('.woot--bubble-holder');
      if (el) {
        el.style.zIndex = message.config.channelConfig.widgetZindex;
      }

      if (window.$chatwoot.user) {
        IFrameHelper.sendMessage('set-user', window.$chatwoot.user);
      }
      dispatchWindowEvent(EVENT_NAME);
    },

    setBubbleLabel(message) {
      if (window.$chatwoot.hideMessageBubble) {
        // eslint-disable-next-line no-console
        console.info(
          '%c💡 LimeChat Widget is disabled by Admin, It can be Enabled from LimeChat Dashboard',
          'color:white;font-family:system-ui;font-size:0.8rem;background-color: #6bac1b;border-radius: 0.4rem;padding: 0.2rem;' // eslint-disable-line max-len
        );

        return;
      }
      let widget_type =
        window.innerWidth >= 670
          ? window.$chatwoot.type
          : window.$chatwoot.type_mobile;
      setBubbleText(
        window.innerWidth >= 670
          ? window.$chatwoot.launcherTitle
          : window.$chatwoot.launcherTitle_mobile || message.label,
        widget_type
      );
    },

    toggleBubble: () => {
      onBubbleClick();
    },

    onBubbleToggle: (isOpen) => {
      if (isOpen) {
        IFrameHelper.pushEvent('webwidget.triggered');
      }
      // Dispatch toggle event for external listeners
      dispatchWindowEvent(WIDGET_EVENTS.TOGGLE, { isOpen });
    },

    setUnreadMode: (message) => {
      const { unreadMessageCount, unreadMessages } = message;
      const { isOpen } = window.$chatwoot;

      if (unreadMessageCount > 0) {
        if (!isOpen) {
          createUnreadWidgetPopUp(
            unreadMessageCount,
            unreadMessages,
            window.$chatwoot.unreadPopup
          );
        }
      }
    },

    setConversationZeroSetup: () => {
      // Event for setting up conversation for first time users

      IFrameHelper.pushEvent('webwidget.triggered');
      if (isPopupMessageEnabled && popupConfigsJSON) {
        const deviceType = window.innerWidth >= 670 ? 'desktop' : 'mobile';
        const config = popupConfigsJSON[deviceType];

        if (config && !window.$chatwoot.hideMessageBubble) {
          let timer = config.time_to_appear || 1;
          setTimeout(() => {
            createFirstTimeWidgetPopUp(config, widgetColor);
          }, timer * 1000);
        }
      }
    },
  },
  pushEvent: (eventName) => {
    IFrameHelper.sendMessage('push-event', { eventName });
  },
  onLoad: () => {
    const iframe = IFrameHelper.getAppFrame();
    iframe.style.visibility = '';
  },
  loadLimeBubble: (
    widgetColor, // eslint-disable-line no-shadow
    homepopupsettingOptions,
    closepopupsettingOptions,
    popup_configs,
    popup_message_enabled
  ) => {
    loadCSS();

    createBubbleHolder();

    if (!(homepopupsettingOptions?.length === undefined)) {
      homepopupsettingsJSON =
        typeof homepopupsettingOptions === 'object'
          ? homepopupsettingOptions
          : JSON.parse(homepopupsettingOptions);

      if (document.readyState === 'complete') {
        if (
          Cookies.get('wasVisited') !== undefined &&
          Cookies.get('wasPopUpVisited') !== undefined
        ) {
          // do something
        } else {
          Cookies.set('wasVisited', 1);
          if (homepopupsettingsJSON.popupEnabled === true) {
            setTimeout(() => {
              createPopUp(homepopupsettingOptions);
            }, homepopupsettingsJSON.popuptimer * 1000);
          }
        }
      }
    }

    if (!(closepopupsettingOptions?.length === undefined)) {
      closepopupsettingJSON =
        typeof closepopupsettingOptions === 'object'
          ? closepopupsettingOptions
          : JSON.parse(closepopupsettingOptions);
      initializeClosepopupJSON(closepopupsettingJSON);
    }

    if (popup_configs && popup_message_enabled) {
      popupConfigsJSON =
        typeof popup_configs === 'object'
          ? popup_configs
          : JSON.parse(popup_configs);
      isPopupMessageEnabled = popup_message_enabled;

      // Initialize for first time popup config
      const deviceType = window.innerWidth >= 670 ? 'desktop' : 'mobile';
      if (popupConfigsJSON[deviceType]) {
        initializeFirstTimepopupJSON(popupConfigsJSON[deviceType]);
      }
    }

    if (!window.$chatwoot.hideMessageBubble) {
      let chatIcon;

      if (window.innerWidth >= 670) {
        chatIcon = createBubbleIcon(
          {
            className: 'woot-widget-bubble',
            src: window.$chatwoot.bubbleImage,
            target: chatBubble,
          },
          window.$chatwoot.type
        );
      } else {
        chatIcon = createBubbleIcon(
          {
            className: 'woot-widget-bubble',
            src: window.$chatwoot.bubbleImage,
            target: chatBubble,
          },
          window.$chatwoot.type_mobile
        );
      }
      bubbleHolder.appendChild(chatIcon);
      onClickChatBubble();
    }

    let widget_type =
      window.innerWidth >= 670
        ? window.$chatwoot.type
        : window.$chatwoot.type_mobile;
    setBubbleText(
      window.innerWidth >= 670
        ? window.$chatwoot.launcherTitle
        : window.$chatwoot.launcherTitle_mobile,
      widget_type
    );
  },
  setCurrentUrl: () => {
    IFrameHelper.sendMessage('set-current-url', {
      referrerURL: window.location.href,
      referrerHost: window.location.host,
    });
  },
  toggleCloseButton: () => {
    if (window.matchMedia('(max-width: 668px)').matches) {
      IFrameHelper.sendMessage('toggle-close-button', {
        showClose: true,
      });
    } else {
      IFrameHelper.sendMessage('toggle-close-button', {
        showClose: false,
      });
    }
  },
};

const createPopUp = (homepopupsettings) => {
  var div = document.createElement('DIV');
  Cookies.set('wasPopUpVisited', 1);

  let homepopupsettingsJSON2 =
    typeof homepopupsettings === 'object'
      ? homepopupsettings
      : JSON.parse(homepopupsettings);

  div.innerHTML = `
    <div id="lime--popup1" class="lime--overlay">
      <div class="lime--popup">
        <div class="lime--popup2" style="background-image: url(${homepopupsettingsJSON2.popupimageurl})">
          <a id="lime--closepopupmain" class="close" >&times;</a>
          <div id="lime--dialog" class="window">
            <div class="box">
              <div class="newletter-title">
                <h2>${homepopupsettingsJSON2.popuptitle}</h2>
              </div>
              <div class="box-content newleter-content">
                <label>${homepopupsettingsJSON2.popupsubtext}</label>
                <div id="frm_subscribe">
                <form name="subscribe" id="subscribe_popup">
                  <div>
                    <input
                      type="text"
                      value=""
                      name="subscribe_pemail"
                      id="subscribe_pemail"
                      placeholder="${homepopupsettingsJSON2.popupplaceholder}"
                    >
                    <div id="notification"></div>
                    <a class="lime-banner-button" onclick="email_subscribepopup()">
                      <span>${homepopupsettingsJSON2.popupbuttontext}</span>
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>`;

  document.body.appendChild(div);

  function closePopUp() {
    document.body.removeChild(div);
  }

  document.getElementById('lime--closepopupmain').onclick = () => {
    closePopUp();
  };
};
